import styled from 'styled-components';

import { PROCESS_INFO_STATES } from '../../../constants';

export const Container = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconContainer = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${(p) => {
    if (p.status === PROCESS_INFO_STATES.awaiting) {
      return 'var(--color-grey-16)';
    }

    if (p.status === PROCESS_INFO_STATES.wrongCode) {
      return 'var(--color-red-5)';
    }

    if (p.status === PROCESS_INFO_STATES.globalTimeout) {
      return 'var(--color-orange-4)';
    }
  }};
`;

export const IconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  & > svg {
    fill: ${(p) => {
      if (p.status === PROCESS_INFO_STATES.wrongCode) {
        return 'var(--color-red-2)';
      }

      if (p.status === PROCESS_INFO_STATES.globalTimeout) {
        return 'var(--color-orange-1)';
      }
    }};
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${(p) => !p.description && 'justify-content: center;'}
  gap: 4px;
`;

export const Title = styled.h3`
  margin-bottom: 0px;

  font: var(--font-large-17_2);
`;

export const Description = styled.p`
  margin-bottom: 0px;

  font: var(--font-regular-15);
`;
